import api from "api/config";

export const GetHousekeepingRoomsAPI = async ({
  hotelId,
  tab = "all",
  reservationFilter = "arrival",
  search,
  page = 1,
  pageSize = 20,
}) => {
  const params = new URLSearchParams({
    hotelId,
    tab,
    reservationFilter,
    page,
    pageSize,
    ...(search && { search }),
  });

  const response = await api({
    method: "GET",
    url: `/api/v1/housekeeping/rooms?${params}`,
  });

  return response;
};

export const GetHousekeepingRoomDetailsAPI = async ({ hotelId, roomId }) => {
  const params = new URLSearchParams({
    hotelId,
  });

  const response = await api({
    method: "GET",
    url: `/api/v1/housekeeping/rooms/${roomId}?${params}`,
  });

  return response;
};

export const GetHousekeepingCountersAPI = async ({ hotelId, reservationFilter = "all" }) => {
  const params = new URLSearchParams({
    hotelId,
    reservationFilter,
  });

  const response = await api({
    method: "GET",
    url: `/api/v1/housekeeping/stats/counters?${params}`,
  });

  return response;
};

export const GetHousekeepingPieAPI = async ({ hotelId, reservationFilter = "all" }) => {
  const params = new URLSearchParams({
    hotelId,
    reservationFilter,
  });

  const response = await api({
    method: "GET",
    url: `/api/v1/housekeeping/stats/pie?${params}`,
  });

  return response;
};

export const GetHousekeepersAPI = async (hotelId) => {
  const params = new URLSearchParams({
    hotelId,
  });

  const response = await api({
    method: "GET",
    url: `/api/v1/housekeeping/housekeepers?${params}`,
  });

  return response;
};

export const UpdateHousekeepingRoomStatusAPI = async ({ roomId, hotelId, status, version }) => {
  const response = await api({
    method: "PATCH",
    url: `/api/v1/housekeeping/rooms/${roomId}/status`,
    data: {
      hotelId,
      status,
      version,
    },
  });

  return response;
};

export const AssignHousekeepingRoomAPI = async ({ roomId, hotelId, assigneeUserId, version }) => {
  const response = await api({
    method: "POST",
    url: `/api/v1/housekeeping/rooms/${roomId}/assign`,
    data: {
      hotelId,
      assigneeUserId,
      version,
    },
  });

  return response;
};

export const RemoveHousekeepingRoomAssignmentAPI = async ({ roomId, hotelId, version }) => {
  const response = await api({
    method: "DELETE",
    url: `/api/v1/housekeeping/rooms/${roomId}/assign`,
    data: {
      hotelId,
      version,
    },
  });

  return response;
};

export const SelfAssignHousekeepingRoomAPI = async ({ roomId, hotelId, version }) => {
  const response = await api({
    method: "POST",
    url: `/api/v1/housekeeping/rooms/${roomId}/self-assign`,
    data: {
      hotelId,
      version,
    },
  });

  return response;
};

export const SaveHousekeepingRoomNoteAPI = async ({ roomId, hotelId, text, version }) => {
  const response = await api({
    method: "PUT",
    url: `/api/v1/housekeeping/rooms/${roomId}/note`,
    data: {
      hotelId,
      text,
      version,
    },
  });

  return response;
};

export const DeleteHousekeepingRoomNoteAPI = async ({ roomId, hotelId }) => {
  const response = await api({
    method: "DELETE",
    url: `/api/v1/housekeeping/rooms/${roomId}/note`,
    data: {
      hotelId,
    },
  });

  return response;
};

export const RetryHousekeepingJobAPI = async (jobId) => {
  const response = await api({
    method: "POST",
    url: `/api/v1/housekeeping/jobs/${jobId}/retry`,
  });

  return response;
};
